import $ from 'jquery';
import Card from './card';
import {
  loadNextConfiguration,
  showMagnus,
  plotArrow
} from '../utils';
import { CORRECT_ANSWER_AUDIO, WRONG_ANSWER_AUDIO } from '../utils/constants';

export default class Options {
  constructor() {
    let that = this;

    /**
    * @name options-show
    * @function
    * @param {config}
    * @description: Event listener for show options
    */
    $(document).bind('options-show', function (e, config) {
      $('.right-box-content').append(`<div class='options'></div>`)
      that.displayOptions(config)
    }).bind(that);

    /**
    * @name options-hide
    * @function
    * @param {config}
    * @description: Event listener for hide options
    */
    $(document).bind('options-hide', function (e, config) {
      $('.options').remove();
    }).bind(that);
  }

  /**
  * @name displayOptions
  * @function
  * @param {config}
  * @description: Display the options
  */
  displayOptions(config) {
    let answers = config.answer,
      validateAnswer = config.validateAnswer,
      next = config.next ? config.next : null,
      magnusCorrectAnswer = config.magnusCorrectAnswer,
      magnusWrongAnswer = config.magnusWrongAnswer,
      count = config.count;

    let body = `
        <div class="options-section">
            <div class="options-section-wrapper">
                <div class="body">
                    <div class="answer-container full-height flex-horizontal-center">
                        <span class="btn answer" data-answer='0'>${answers[0] ? answers[0] : 'N/A'}</span>
                        <span class="btn answer" data-answer='1'>${answers[1] ? answers[1] : 'N/A'}</span>
                        ${answers[2] ? '<span class="btn answer" data-answer="2">' + answers[2] + '</span>' : ''}
                        ${answers[3] ? '<span class="btn answer" data-answer="3">' + answers[3] + '</span>' : ''}     
                </div>
            </div>
        </div>`;

    $('.options').html(body)
    $('.options').css('opacity', '1');

    $('.answer').click(function () {
      let userAnswer = parseInt($(this).attr('data-answer'), 10);

      //if ($('.answer-container').find('.selected').length < 1) {
        $('.answer').removeClass('selected');
        $(this).addClass('selected');

        if (config.id === 0)
          Card.result = 0;

        if (userAnswer === validateAnswer.rightAnswer) {
          var text = $(this).text();
          $(document).trigger('get-value', [text, true]);
          if (config.isQA) {
            Card.result = Card.result + 1;
          }

          $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO)

          if (config.magnusCorrectAnswer) {
            showMagnus(magnusCorrectAnswer)
            next && loadNextConfiguration(magnusCorrectAnswer.waitTime || 4000, next)
          } else {
            next && loadNextConfiguration(2000, next)
          }
        } else {

          $(document).trigger('audio-play', WRONG_ANSWER_AUDIO)

          if (config.magnusWrongAnswer) {
            if(!config.validateCounter) {
              $(this).removeClass('selected');
              showMagnus(magnusWrongAnswer);
              next && loadNextConfiguration(magnusWrongAnswer.waitTime, next)
            } else {
              if(count === 0) {
                showMagnus(magnusWrongAnswer);
                $(document).trigger('get-value', [config.rightAnswer, false]);
                next && loadNextConfiguration(magnusWrongAnswer.waitTime, next)
              } else {
                count --;
              }
            }
          } else {
            next && loadNextConfiguration(1000, next)
          }
        }

        if (config.highlightSquare) {
          var square = document.getElementsByClassName(config.highlightSquare);
          $(square[0]).addClass("filled-square");
        }
        if (config.canvas) {
          let offsetFromx = null,
            offsetFromy = null,
            offsetTox = null,
            offsetToy = null,
            screenWidth = $('.page-body').width(),
            screenHeight = $('.page-body').height();
          $('.chessboard-container').append(`<canvas id="myCanvas" width=${screenWidth} height=${screenHeight} ></canvas>`)
          $('#myCanvas').addClass('show').removeClass('hide');
          var c = document.getElementById("myCanvas");
          var ctx = c.getContext("2d");
          ctx.clearRect(0, 0, c.width, c.height);

          if (config.canvas.offset) {
            offsetFromx = config.canvas.offset[0];
            offsetFromy = config.canvas.offset[1];
            offsetTox = config.canvas.offset[2];
            offsetToy = config.canvas.offset[3];
          }

          plotArrow(ctx, config.canvas.from, config.canvas.to, offsetFromx, offsetFromy, offsetTox, offsetToy, null, null, config.canvas.color);
        }
      //}
    });
  }
}


// WEBPACK FOOTER //
// ./src/components/options.js